var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6842 10.416C11.8947 10.608 12 10.84 12 11.112C12 11.352 11.9035 11.56 11.7105 11.736C11.5175 11.912 11.2895 12 11.0263 12C10.7456 12 10.4912 11.888 10.2632 11.664L6 7.224L1.76316 11.664C1.53509 11.888 1.2807 12 1 12C0.736842 12 0.5 11.912 0.289474 11.736C0.0964913 11.56 0 11.344 0 11.088C0 10.848 0.105263 10.624 0.315789 10.416L4.68421 5.928L0.5 1.584C0.289474 1.36 0.184211 1.136 0.184211 0.912C0.184211 0.656 0.280702 0.44 0.473684 0.264C0.684211 0.0879998 0.912281 0 1.15789 0C1.4386 0 1.69298 0.112 1.92105 0.335999L6 4.608L10.0789 0.335999C10.307 0.112 10.5614 0 10.8421 0C11.1053 0 11.3333 0.0879998 11.5263 0.264C11.7193 0.44 11.8158 0.647999 11.8158 0.887999C11.8158 1.16 11.7105 1.392 11.5 1.584L7.31579 5.928L11.6842 10.416Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearText);
export default __webpack_public_path__ + "static/media/ClearText.ba719e2a3c6817458bf07c46565804fd.svg";
export { ForwardRef as ReactComponent };